export const CREATE_STUDENT = 'CREATE_STUDENT';
export const FETCH_STUDENT = 'FETCH_STUDENT';
export const UPDATE_STUDENT = 'UPDATE_STUDENT';
